import React, { useEffect, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { useQuery, useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../conexoes/api'
import '../../css/pavFiltros/filtros.css'
import {
  filtrosArrayBarra,
  recarregarBarraFiltragem,
  revelarBarraFiltragem
} from '../../redux/actions'
import { DispositivosService } from '../../services/http/dispositivos.service'
import { setaDropdown } from '../../utils/alternanciaIcones'
import decryptJWT from '../../utils/decryptJWT'
import { isPortal } from '../../utils/nivelCliente'
import SelectGenerico from '../componentesModais/selects/selectGenerico'

const CACHE_10MINUTOS = 600000

function Filtros(props) {
  const portalCliente = isPortal()
  const queryClient = useQueryClient()

  const [dadoSelectGrupo, setDadoSelectGrupo] = useState([])
  const [arrOperadoraPlano, setArrOperadoraPlano] = useState([])
  const [arrOperadoraPlanoFiltrados, setArrOperadoraPlanoFiltrados] = useState(
    []
  )
  const [filtroOperadora, setFiltroOperadora] = useState('')
  const [filtroTecnologia, setFiltroTecnologia] = useState('')
  const [filtroPlanoTipo, setFiltroPlanoTipo] = useState('')
  const [filtroPlanoMinimo, setFiltroPlanoMinimo] = useState('')
  const [filtroPlanoMaximo, setFiltroPlanoMaximo] = useState('')
  const [filtroGrupo, setFiltroGrupo] = useState('')
  const [filtroOperadoraPlano, setFiltroOperadoraPlano] = useState('Selecione')
  const [filtroCodigoOperadoraPlano, setFiltroCodigoOperadoraPlano] =
    useState(0)
  const [, setDummy] = useState('')
  const [revelarSelectOperadoraPlano, setRevelarSelectOperadoraPlano] =
    useState(false)

  const [operadoras, setOperadoras] = useState([])

  const despacho = useDispatch()
  let recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let arrayFiltrosSimcard = []

  const { getOperadoras } = DispositivosService

  useEffect(() => {
    const cachedData = queryClient.getQueryData(['operadoras-dashboard'])
    if (cachedData?.length) {
      const lista = cachedData.map((item) => ({
        id: item.cd_dsp_operadora,
        nome: item.ds_dsp_operadora
      }))
      setOperadoras(lista)
    }
  }, [queryClient])

  const { isFetching } = useQuery(
    ['operadoras-dashboard'],
    () => getOperadoras(),
    {
      onSuccess: (data) => {
        if (data?.length) {
          const lista = data.map((item) => ({
            id: item.cd_dsp_operadora,
            nome: item.ds_dsp_operadora
          }))
          setOperadoras(lista)
        }
      },
      staleTime: CACHE_10MINUTOS,
      cacheTime: CACHE_10MINUTOS,
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  function hendlerGetdadosFiltros() {
    if (!filtros.vazio) {
      if (filtros.OPERADORA) setFiltroOperadora(filtros.OPERADORA)
      if (filtros.TECNOLOGIA) setFiltroTecnologia(filtros.TECNOLOGIA)
      if (filtros.OPERADORA_PLANO) {
        setFiltroOperadoraPlano(filtros.OPERADORA_PLANO)
        setFiltroCodigoOperadoraPlano(filtros.OPERADORA_PLANO)
      }
      if (filtros.PLANO_TIPO) setFiltroPlanoTipo(filtros.PLANO_TIPO)
      if (filtros.PLANO_MIN) setFiltroPlanoMinimo(filtros.PLANO_MIN)
      if (filtros.PLANO_MAX) setFiltroPlanoMaximo(filtros.PLANO_MAX)
      if (filtros.GRUPO) setFiltroGrupo(filtros.GRUPO)
    }
  }

  useEffect(() => {
    hendlerGetdadosFiltros()
  }, [])

  function handlerCheck(element, nome) {
    return filtros[element] == nome
  }

  function handleFuncaoEstadosRedux() {
    if (filtroOperadora !== '' && filtroOperadora) {
      arrayFiltrosSimcard.push('Operadora: ' + filtroOperadora + '?OPERADORA')
    }
    if (filtroTecnologia !== '' && filtroTecnologia) {
      arrayFiltrosSimcard.push(
        'Tecnologia: ' + filtroTecnologia + '?TECNOLOGIA'
      )
    }
    if (
      filtroOperadoraPlano !== '' &&
      filtroOperadoraPlano !== 'Planos' &&
      filtroOperadoraPlano != 'Selecione'
    ) {
      const strPlano = isNaN(filtroOperadoraPlano)
        ? filtroOperadoraPlano
        : filtros.DS_OPERADORA_PLANO
      arrayFiltrosSimcard.push(
        'Operadora plano: ' + strPlano + '?OPERADORA_PLANO'
      )
    }
    if (
      filtroPlanoMinimo !== '' &&
      filtroPlanoMaximo !== '' &&
      filtroPlanoMinimo &&
      filtroPlanoMaximo
    ) {
      arrayFiltrosSimcard.push(
        'Plano: entre ' +
          filtroPlanoMinimo +
          'MB e ' +
          filtroPlanoMaximo +
          'MB' +
          '?PLANO_MIN'
      )
    } else if (filtroPlanoMinimo !== '' && filtroPlanoMinimo) {
      arrayFiltrosSimcard.push(
        'Plano: a partir de ' + filtroPlanoMinimo + 'MB' + '?PLANO_MIN'
      )
    } else if (filtroPlanoMaximo !== '' && filtroPlanoMaximo) {
      arrayFiltrosSimcard.push(
        'Plano: até ' + filtroPlanoMaximo + 'MB' + '?PLANO_MAX'
      )
    }
    if (filtroGrupo !== '' && filtroGrupo) {
      const strGrupo = isNaN(filtroGrupo) ? filtroGrupo : filtros.DS_GRUPO
      arrayFiltrosSimcard.push('Grupo: ' + strGrupo + '?GRUPO')
    }
    despacho(filtrosArrayBarra(arrayFiltrosSimcard))
    despacho(revelarBarraFiltragem(true))
    despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
  }

  useEffect(() => {
    async function carregarGrupos() {
      let todosGrupos = []

      //carrega os 3 grupos padroes
      const gruposPadroes = await api_gateway.get(
        '/m1/consultar/simcard_grupo?fl_padrao=1'
      )
      todosGrupos = gruposPadroes.data.dados

      // carrega o grupos do cliente
      const { data } = await api_gateway.get(
        '/m1/consultar/simcard_grupo?fl_padrao=0&&cd_pav_cliente=' +
          parseInt(decryptJWT('codigoCliente'))
      )
      await data.dados.map((item) => {
        todosGrupos.push(item)
      })
      setDadoSelectGrupo(todosGrupos)
    }
    carregarGrupos()
  }, [])

  useEffect(() => {
    //Check se todas as variaveis estao limpas
    function handlerCheckarTudoLimpo(verificador = []) {
      if (filtroOperadora == '') verificador.push(1)
      if (filtroOperadoraPlano == '') verificador.push(1)
      if (filtroTecnologia == '') verificador.push(1)
      if (filtroPlanoTipo == '') verificador.push(1)
      if (filtroPlanoMinimo == '') verificador.push(1)
      if (filtroPlanoMaximo == '') verificador.push(1)
      if (filtroGrupo == '') verificador.push(1)
      //tamanho igual a quantidade de variaveis
      if (verificador.length === 7) return false
      return true
    }

    async function handlerAtivarBotoes() {
      //se for alterado algo vai abilitar os botoes
      if (
        props.primeiraVez &&
        !props.foiLimpado &&
        (await handlerCheckarTudoLimpo())
      ) {
        props.setFoiSelecionado(true)
      }
    }

    //limpa os dados de todas as variaveis
    if (props.foiLimpado) {
      setFiltroOperadora('')
      setFiltroOperadoraPlano('Selecione')
      setFiltroCodigoOperadoraPlano(0)
      setFiltroTecnologia('')
      setFiltroPlanoTipo('')
      setFiltroPlanoMinimo('')
      setFiltroPlanoMaximo('')
      setFiltroGrupo('')
      props.setFoiLimpado(false)
    }

    handlerAtivarBotoes()
    props.setPrimeiraVez(true)
  }, [
    filtroOperadora,
    filtroTecnologia,
    filtroOperadoraPlano,
    filtroCodigoOperadoraPlano,
    filtroPlanoTipo,
    filtroPlanoMinimo,
    filtroPlanoMaximo,
    filtroGrupo,
    props.foiLimpado
  ])

  const operadoraPlanoObj = arrOperadoraPlanoFiltrados.find(
    (item) =>
      item.codigo === filtroCodigoOperadoraPlano &&
      item.descricao1 === filtroOperadoraPlano
  )

  const nomePlanoOperadora =
    filtroOperadoraPlano !== 'Selecione'
      ? operadoraPlanoObj?.descricao1 || filtros.DS_OPERADORA_PLANO
      : 'Selecione'

  const sufixoPlanoOperadora =
    filtroOperadoraPlano !== 'Selecione' &&
    (operadoraPlanoObj?.linhas || filtros.LINHAS)
      ? `(${operadoraPlanoObj?.linhas || filtros.LINHAS})`
      : ''

  const placeholderPlanoOperadora =
    nomePlanoOperadora +
    (sufixoPlanoOperadora ? ` ${sufixoPlanoOperadora}` : '')

  function handleChangeOperadora(op) {
    setFiltroOperadora(op)
    if (filtroOperadora && op) {
      // zerar filtro plano quando troca operadora
      setFiltroOperadoraPlano('Selecione')
      setFiltroCodigoOperadoraPlano(0)
      setFiltroPlanoTipo('')
    }
  }

  return (
    <Form
      ref={props.modal}
      onSubmit={(e, fa) => {
        let newItem = false
        if (filtroOperadoraPlano && filtroOperadoraPlano != 'Selecione') {
          if (operadoraPlanoObj?.codigo) {
            newItem = {
              OPERADORA_PLANO: operadoraPlanoObj?.codigo,
              DS_OPERADORA_PLANO: operadoraPlanoObj?.descricao1,
              LINHAS: operadoraPlanoObj?.linhas,
              PLANO_TIPO: operadoraPlanoObj?.plano_tipo
            }
          } else if (filtroOperadoraPlano && filtros.OPERADORA_PLANO) {
            newItem = {
              OPERADORA_PLANO: filtros.OPERADORA_PLANO,
              DS_OPERADORA_PLANO: filtros.DS_OPERADORA_PLANO,
              LINHAS: filtros.LINHAS,
              PLANO_TIPO: filtros.PLANO_TIPO
            }
          }
        }
        if (isNaN(filtroGrupo) || filtros.DS_GRUPO) {
          if (!newItem) newItem = {}
          newItem.DS_GRUPO = isNaN(filtroGrupo) ? filtroGrupo : filtros.DS_GRUPO
        }
        props.enviarFiltros(e, fa, newItem)
      }}
      className="drop-acoes-container-dashboard-dispositivos"
    >
      <div className="campo-select-triangulo-menor-cor-2" />
      <div className="drop-acoes-corpo-dashboard-dispositivos fundo-cor-7">
        <div className="drop-acoes-lista-menu">
          <div
            className="drop-filtros-menu-dashboard-dispositivos"
            onClick={(e) =>
              props.dropFiltros(
                e,
                'filtro-operadora',
                'imagem-filtro-operadora'
              )
            }
          >
            <Form.Label className="drop-filtros-menu-label fonte-cor-1 label-filtros-seta">
              Operadora
            </Form.Label>
            <img
              id="imagem-filtro-operadora"
              className="drop-acoes-menu-icone-desativado nao-selecionavel"
              src={setaDropdown()}
            />
          </div>
          <div className="drop-filtros-divisora-dashboard-dispositivos campo-select-divisor-cor-1" />
          <div
            id="filtro-operadora"
            className="drop-filtros-lista-submenu-simcard dropdown-desativado-filtros"
          >
            {isFetching ? (
              <div className="carregando-dashboard-dispositivos fonte-cor-1">
                Carregando
                <span className="dots" />
              </div>
            ) : (
              operadoras.map((op, index) => (
                <React.Fragment key={op.id}>
                  <label
                    className="label-radio-filtros width-19rem fonte-cor-1"
                    onChange={() => handleChangeOperadora(op.nome)}
                  >
                    {op.nome}
                    <input
                      defaultChecked={handlerCheck('OPERADORA', op.nome)}
                      type="radio"
                      id={`OPERADORA_${op.nome}`}
                      name="OPERADORA"
                      value={op.nome}
                    />
                    <span className="checkbox-filtros campo-texto-cor-3" />
                  </label>
                  {index < operadoras.length - 1 && (
                    <div className="drop-filtros-divisora-dashboard-dispositivos campo-select-divisor-cor-1" />
                  )}
                </React.Fragment>
              ))
            )}

            {!revelarSelectOperadoraPlano && (
              <div className="drop-filtros-divisora-dashboard-dispositivos campo-select-divisor-cor-1" />
            )}
          </div>
          {/* ------------------- */}
          {filtroOperadora && !portalCliente && (
            <>
              <div
                className="drop-filtros-menu-dashboard-dispositivos"
                onClick={(e) =>
                  props.dropFiltros(e, 'filtro-id', 'imagem-filtro-id')
                }
              >
                <Form.Label className="drop-filtros-menu-label fonte-cor-1 label-filtros-seta">
                  Plano
                </Form.Label>
                <img
                  id="imagem-filtro-id"
                  className="drop-acoes-menu-icone-desativado nao-selecionavel"
                  src={setaDropdown()}
                />
              </div>
              <div className="drop-filtros-divisora-dashboard-dispositivos campo-select-divisor-cor-1" />
              <div
                id="filtro-id"
                className="drop-filtros-lista-submenu dropdown-desativado-filtros"
              >
                <Form.Group className="select-generico-filtro-dashboard-dispositivos">
                  {revelarSelectOperadoraPlano === false && (
                    <Button
                      className="campo-texto-cor-3 campo-select"
                      onClick={() =>
                        setRevelarSelectOperadoraPlano(
                          !revelarSelectOperadoraPlano
                        )
                      }
                    >
                      <div className="fonte-cor-1 label-campo campo-texto-select-tamanho-dasboard-detalhamento">
                        {nomePlanoOperadora}
                        {nomePlanoOperadora !== 'Selecione' &&
                          sufixoPlanoOperadora && (
                            <span className="span-sufixo-cinza">
                              {' '}
                              {sufixoPlanoOperadora}
                            </span>
                          )}
                      </div>
                      <img
                        className={
                          revelarSelectOperadoraPlano
                            ? 'campo-select-icone-ativado nao-selecionavel'
                            : 'campo-select-icone-desativado nao-selecionavel'
                        }
                        src={setaDropdown()}
                        alt="drop"
                      />
                    </Button>
                  )}
                  {revelarSelectOperadoraPlano === true && (
                    <SelectGenerico
                      paramRota="nomeplano_operadora"
                      paramCampo1={filtroOperadora}
                      paramCampo2={null}
                      paramCampo3={null}
                      paramCampo4={null}
                      setCodigo={setFiltroCodigoOperadoraPlano}
                      setDescricao1={setFiltroOperadoraPlano}
                      setDescricao2={setDummy}
                      setDescricao3={setDummy}
                      setDescricao4={setDummy}
                      setRevelarSelect={setRevelarSelectOperadoraPlano}
                      placeholder={placeholderPlanoOperadora}
                      sufixo=""
                      setDados={setArrOperadoraPlano}
                      dados={arrOperadoraPlano}
                      setDadosFiltrados={setArrOperadoraPlanoFiltrados}
                    />
                  )}
                </Form.Group>
                <div className="drop-filtros-divisora-dashboard-dispositivos campo-select-divisor-cor-1" />
              </div>
            </>
          )}

          <div
            className="drop-filtros-menu-dashboard-dispositivos"
            onClick={(e) =>
              props.dropFiltros(e, 'filtro-grupo', 'imagem-filtro-grupo')
            }
          >
            <Form.Label className="drop-filtros-menu-label fonte-cor-1 label-filtros-seta">
              Grupo{' '}
            </Form.Label>
            <img
              id="imagem-filtro-grupo"
              className="drop-acoes-menu-icone-desativado nao-selecionavel"
              src={setaDropdown()}
            />
          </div>
          <div
            id="filtro-grupo"
            className="drop-filtros-lista-submenu-simcard dropdown-desativado-filtros"
          >
            {dadoSelectGrupo.map((grupo) => (
              <React.Fragment key={grupo.cd_dsp_simcard_grupo}>
                <div className="drop-filtros-divisora-dashboard-dispositivos campo-select-divisor-cor-1" />
                <label
                  className="label-radio-filtros width-19rem fonte-cor-1"
                  onChange={() => setFiltroGrupo(grupo.ds_nome)}
                >
                  {grupo.ds_nome}
                  <input
                    defaultChecked={handlerCheck(
                      'GRUPO',
                      grupo.cd_dsp_simcard_grupo
                    )}
                    type="radio"
                    name="GRUPO"
                    value={grupo.cd_dsp_simcard_grupo}
                    onClick={(e) => setFiltroGrupo(e.target.value)}
                  />
                  <span className="checkbox-filtros campo-texto-cor-3" />
                </label>
              </React.Fragment>
            ))}
          </div>

          <div className="drop-filtros-divisora-final-dashboard-dispositivos campo-select-divisor-cor-1" />
          <div className="botao-central-filtros-dashboard-dispositivos">
            <Col>
              <Button
                disabled={props.foiSelecionado ? false : true}
                type="submit"
                onClick={() => handleFuncaoEstadosRedux()}
                className={
                  props.foiSelecionado
                    ? 'botao-aplicar-filtro-habilitado fonte-cor-4'
                    : 'botao-aplicar-filtro-disable'
                }
                variant="default"
              >
                Filtrar
              </Button>
              <Button
                disabled={props.foiSelecionado ? false : true}
                type="button"
                onClick={props.limparFiltros}
                className={
                  props.foiSelecionado
                    ? 'botao-limpar-filtro-habilitado fonte-cor-2'
                    : 'botao-limpar-filtro-disable'
                }
                variant="default"
              >
                Limpar
              </Button>
            </Col>
          </div>
        </div>
      </div>
    </Form>
  )
}

export default Filtros
